
import { EnrichedAssignmentMetricsByWorkload } from '@/pages/OperationsInsights/types/AssignmentMetricsResponseEnriched';

/**
 * Transform data for High Chart Series - Assignments Completion Time in Minute By Workload [PF-1671]
 * @param metrics
 */
export const tfCsAssignmentCompletionTimeByWorkload = (metrics: EnrichedAssignmentMetricsByWorkload[]) => {

    const xAxisCategories: string[] = [];
    // for stacked bar, data label is enabled by default. So need to disable it
    const dataLabels = { enabled: false };
    const chartSeries = [
        {
            type: 'bar' as const,
            direction: 'horizontal',

            name: 'Average Completion Time',
            color: '#2caffe', // light-blue
            dataLabels,
            data: [] as number[][]
        }
    ];
    for (const metric of metrics) {
        xAxisCategories.push(metric.name);

        // Assignment Completion Time in Minutes
        chartSeries[0].data.push([ xAxisCategories.length - 1, metric.averageCompletionTimeInMinutes ?? 0 ]);
    }
    return { xAxisCategories, chartSeries };
};